import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import MediaSwitch from "../../../media-switch";
import SliderProvider, { useSliderContext } from "@default/general-components/slider/context";
import { Slide, Slider } from "@default/general-components/slider/slider";
import { SliderDots } from "@default/general-components/slider/slider-dots";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";
import { useSelector } from "react-redux";
import useTranslate from "@default/hooks/use-translate";

const StorySlides = ({ items }) => {
  const { selectedIndex } = useSliderContext();
  return items.map((item, index) => (
    <Slide key={index}>
      <div className="inner-slide" data-id={index}>
        <MediaSwitch
          media={item.entity}
          item={item.entity}
          autoplay={index === selectedIndex}
          forcePlay={index === selectedIndex}
          loop={false}
        />
      </div>
    </Slide>
  ));
};

const StorySliderNavigation = () => {
  const { emblaApi } = useSliderContext();
  const { simpleDesign } = useAccessibilityContext();
  const microSite = useSelector((s) => s.appStore.microSite);
  const _t = useTranslate();

  if (!simpleDesign && !microSite) return null;

  return (
    <>
      <button
        className="story-slider__btn story-slider__btn--prev"
        onClick={() => emblaApi?.scrollPrev()}
        aria-label={_t("accessibility.previous_slide")}
      >
        <span aria-hidden="true">←</span>
      </button>
      <button
        className="story-slider__btn story-slider__btn--next"
        onClick={() => emblaApi?.scrollNext()}
        aria-label={_t("accessibility.next_slide")}
      >
        <span aria-hidden="true">→</span>
      </button>
    </>
  );
};

const StorySlider = ({ content }) => {
  const items = content.fieldMultimediaRawField?.list ?? [];
  const slideTypes = items.map((item) => item.entity?.entityBundle ?? "image");

  return (
    <section className={classNames("paragraph-media-gallery", "story-slider")}>
      <SliderProvider
        options={{ fade: true, autoplay: true, autoplaySpeed: 3000, loop: true }}
        slideTypes={slideTypes}
      >
        <Slider>
          <StorySlides items={items} />
        </Slider>
        <StorySliderNavigation />
        <SliderDots />
      </SliderProvider>
    </section>
  );
};

StorySlider.propTypes = {
  content: PropTypes.shape({
    fieldMultimediaRawField: PropTypes.shape({
      list: PropTypes.arrayOf(
        PropTypes.shape({
          entity: PropTypes.shape({
            entityBundle: PropTypes.string,
            fieldCaption: PropTypes.string,
            fieldCredits: PropTypes.string,
            fieldMediaImage: PropTypes.shape({
              alt: PropTypes.string,
              title: PropTypes.string,
              style: PropTypes.shape({
                url: PropTypes.string,
                width: PropTypes.number,
                height: PropTypes.number,
              }),
            }),
          }),
        })
      ),
    }),
  }),
};

export default StorySlider;
